var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-right",class:{ 'shake-that': _vm.isShaking }},[(_vm.message)?_c('em',[_vm._v(_vm._s(_vm._f("__t")(_vm.message,"input-error__" + _vm.toSlug(_vm.message))))]):_c('em',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }